import React, { Component } from 'react';
import './index.less'

export default class Privacy extends Component {

    componentDidMount(){
        // document.title = '用友云隐私政策';
        document.title = '隐私政策';
    }

    render() {
        return (
            <div className="content-body">
                <h3 className="center">用友云隐私政策</h3>
                {/* <p className="right"> 最近更新时间：2022年1月10日 </p> */}
                <p className="right"> 生效时间：2019年4月19日 </p>
                <p>
                    欢迎您使用用友云产品及服务！<br />
                    用友网络科技股份有限公司（以下简称“用友云”或“我们”）及其关联公司为保护您的用户信息安全可控，将按照适用的法律法规要求，对您的用户信息采取安全保护措施。因此，用友云制定本《用友云隐私权政策》（以下或简称“隐私权政策”）并提醒您：
                    <strong>在使用用友云的各项服务前，请您务必仔细阅读并透彻理解本隐私权政策，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用用友云服务，将被视为对本隐私权政策的接受和认可。</strong><br/>
                    用友云（以下或称为“我们”）尊重并保护用户信息，并且将以高度勤勉和审慎的义务对待这些信息。在您使用了用友云提供的服务时，我们将按照本隐私权政策收集、处理及披露您的信息。我们希望通过本隐私权政策向您清晰地介绍我们对您信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。<br />
                    本隐私权政策主要包括以下内容：<br />
                    一、定义<br />
                    二、适用范围<br />
                    三、用户个人信息的收集与使用<br />
                    四、用户个人信息共享、转让、公开披露的方式<br />
                    五、用户业务数据和公开信息<br />
                    六、用户个人信息的查询、更正与删除<br />
                    七、cookie和同类技术的使用方式<br />
                    八、用户个人信息的安全保护措施<br />
                    九、我们如何存储您的个人信息<br />
                    十、未成年人用户个人信息的特别约定<br />
                    十一、用户其他权利条款<br />
                    十二、隐私权政策的更新<br />
                    十三、我们的联系方式<br />
                </p>
                <h4>一、定义</h4>
                <p>
                    <strong>1.1. 用友云网站：</strong>
                    指用友云官网（域名为：
                    <a href="http://www.yonyoucloud.com">www.yonyoucloud.com</a>
                    ）及相应的客户端（即APP，如有）。<br />
                    <strong>1.2. 用友云:</strong>
                    除非另有约定，指用友云网站的运营者用友网络科技股份有限公司。<br />
                    <strong>1.3. 用友云关联公司：</strong>
                    指用友网络科技股份有限公司最新上市年报披露的关联公司，具体详见上海证券交易所官方网站。<br />
                    <strong>1.4. 用友云服务：</strong>
                    涵盖用友入口产品（如友空间）、用友平台产品、用友生态服务以及用友领域云服务。其中用友领域云服务涵盖财务云、营销云、采购云、协同云、人力云、制造云、建造云、企业金融云、烟草云、教育云、汽车云、政务云、建筑云、传媒与电信云、红火台、链融云、能源云、精智工业云等。上述服务的类别与内容可能会根据用友云的业务规划而发生变化，具体可参见用友云网站
                    <a href="https://www.yonyou.com/YonBIP/">https://www.yonyou.com/YonBIP/</a>。<br />
                    <strong>1.5. 用户：指购买用友云的云服务产品并接受相关技术及网络支持服务的个人、企业、公司、事业单位等其他依据中华人民共和国法律享有民事权利并能独立承担民事义务的组织。</strong><br />
                    <strong>1.6. 用户个人信息：</strong>
                    用户个人信息是指用户向用友云提交的或者用友云收集的用户信息，上述信息可以电子或者其他方式记录，并可单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况。<br />
                    <strong>1.7. 个人敏感信息：</strong>
                    是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。用友云服务的个人敏感信息包括身份证件号码、手机号码、个人生物识别信息、银行账号、财产信息、交易信息、14岁以下（含）儿童的个人信息等。<br />
                    <strong>1.8. 业务数据：</strong>
                    不同于用户信息，是指用友云的用户利用用友云的服务上传、下载、分发等通过用友云的技术服务处理的数据。<br />
                    <strong>1.9. 收集：</strong>
                    指用友云获得对用户的个人信息的控制权的行为，包括由用户主动提供、通过与用户交互或记录用户行为等自动采集，以及通过共享、转让、搜集公开信息间接获取等方式。<br />
                    <strong>1.10. 用友云企业/组织用户：</strong>
                    指通过企业或其他组织授权管理员或直接通过法定代表人注册成为用友云用户，并以管理员身份通过用友云管理平台上传企业/组织员工通讯录搭建企业组织架构后，代表企业组织开通、管理和使用用友云服务。用友云企业/组织用户包括但不限于公司、政府机构、其他组织、合伙企业或个体工商户等。<br />
                    <strong>1.11. 用友云企业/组织管理员：</strong>
                    指经用友云企业/组织用户授权或指定，拥有用友云企业/组织用户管理平台系统操作权限，代表企业/组织开通、管理和使用用友云服务的用友云个人用户。<br />
                    <strong>1.12. 用友云个人用户：</strong>
                    是指注册用友云账户的个人用户，不属于任何用友云企业/组织用户，也不具有用友云企业组织管理员权限。<br /> 
                    <strong>1.13. 个人信息控制者：</strong>
                    有权决定个人信息处理目的、方式等的组织或个人。本隐私权政策的用友云服务中的部分个人信息控制者为
                    <strong>用友云企业/组织用户</strong>。<br />
                </p>
                <h4>二、 适用范围</h4>
                <p>
                2.1. 本隐私权政策适用于用友云提供的所有用友云服务，包括用友云基于互联网技术建立且享有著作权的公有云系统服务平台以及基于该云平台提供的各类企业互联网应用服务，及上述服务涉及的移动客户端（即APP，如有）。<br/>
                2.2. 本隐私权政策不适用于其他第三方向您提供的服务。包括用友云市场上入驻的第三方生态伙伴向您提供的服务以及用友云市场售卖的融合型生态产品。<br />
                </p>
                <h4>三、 用户个人信息收集与使用</h4>
                <p>
                    在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：<br/>
                    （1）为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；<br/>
                    （2）为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。<br/>
                    <strong>3.1我们使用您的个人信息的目的</strong><br/>
                    3.1.1. 为了向您提供服务，我们会向您发送信息、通知或与您进行业务沟通，包括但不限于为保证服务完成所必须的验证码、使用服务时所必要的推送通知；<br/> 
                    3.1.2. 我们可能以您的用户个人信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息在分享前会去除您的身份标识并做匿名化处理；<br/>
                    3.1.3. 为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或用友云相关协议、规则的情况，我们可能使用您的用户个人信息整合设备信息、有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施；<br/>
                    3.1.4. 如我们超出本款约定使用您的用户个人信息，或者在超出具有合理范围使用您的用户个人信息前，我们会再次向您告知并征得您的明示同意。<br/>
                    <strong>如果您使用的是移动客户端，我们向您提供您所选择使用的服务，或者保证服务的质量和体验，可能需要您授权开启操作系统权限。如果您不同意授权App获取相关操作系统权限，不会影响您使用我们提供的用友云数字化办公、沟通与协同等基本服务基本业务功能，但您可能无法获得附加服务给您带来的用户体验。</strong><br/>
                    <strong>3.2我们收集您的个人信息的范围</strong><br/>
                    您的个人信息是指单独使用或结合其他信息使用时能够确定您个人身份的信息。您或您所在的企业组织用户注册、使用我们的网站、产品或服务时，我们会向其收集您的必要个人信息，具体如下：<br/>
                    <strong>3.2.1注册账户时收集的信息</strong><br/>
                    您在注册用友云账户时，我们会收集您的如下信息：<br/>
                    3.2.1.1. 
                    <strong>注册成为用友云个人用户：</strong>
                    如您注册成为用友云个人用户，以便我们为您提供基础的用友云服务，我们需要收集您的
                    <strong>手机号码</strong>及<strong>短信验证码</strong>以注册并创建用友云账号，否则您将不能使用上述用友云服务。<br/>
                    3.2.1.2. 
                    <strong>注册成为用友云企业/组织用户：</strong>
                    为注册成为用友云企业组织用户，以便我们基于您所在企业组织的雇佣及管理行为提供用友云服务。您需要提供您的企业/组织名称创建用友云企业/组织账号，否则您将不能基于企业组织管理行为使用用友云服务。注册成为用友云企业组织用户后，您须进一步提供<strong>企业/组织所在地、行业类型、人员规模信息。</strong><br/>
                    <strong>3.2.2使用服务时收集的信息</strong><br/>
                    您在使用用友云服务时，根据您使用具体产品的不同，我们收集您的信息也有所差异，具体参见附件一。
                    <strong>您理解并同意，如您作为企业组织管理员选择开通、管理用友云服务的，您所在企业组织用户的个人用户使用用友云服务相关功能/应用过程中可能会提交或产生相应的信息和数据（下称“企业控制数据”）。您确认并知晓，企业组织用户为上述企业控制数据的控制者，用友云仅根据企业组织用户管理员选择开通、管理和使用上述应用服务处理您的个人信息/数据。企业组织用户上传上述个人用户的个人信息之前，应确保已经事先获得上述个人用户的明确同意，并仅限收集实现企业运营及管理目的所必需的个人用户的个人信息，并已充分告知上述个人用户有关相关数据收集的目的、范围及使用方式等。</strong><br/>
                    <strong>3.3我们收集您的个人信息的方式</strong><br/>
                    3.3.1. 我们将收集和储存在您注册、登录、浏览用友云产品及/或使用用友云服务时主动向用友云提供的个人信息；<br />
                    3.3.2. 我们将收集和储存用友云在向您提供用友云服务的过程中记录的与您有关的个人信息；<br />
                    3.3.3. 我们将收集和储存您通过用友云的客服人员及/或其他渠道主动提交或反馈的个人信息；<br />
                    3.3.4. 我们向关联公司、商业合作伙伴及第三方独立资料来源，收集和储存其合法获得的与您有关的个人信息；<br />
                    3.3.5. 我们可能向依法设立的征信机构查询您的相关信用信息，如信用分、信用报告等。
                </p>
                <h4>四、用户个人信息共享、转让、公开披露的方式</h4>
                <p>
                    <strong>4.1. 共享</strong><br />
                    我们不会与其他组织和个人共享您的用户信息，但以下情况除外：<br />
                    4.1.1. 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；<br />
                    4.1.2. 在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；<br />
                    4.1.3. 与关联公司间共享：为便于我们基于用友云向您提供产品和服务，推荐您可能感兴趣的信息，识别账号异常，保护用友云关联公司或其他用户或公众的人身财产安全免遭侵害，经您的明确同意，您的用户个人信息可能会与我们的关联公司共享。<br />
                    4.1.4. 与授权合作伙伴共享：如果您通过用友云使用的某些服务是由用友云的供应商、合作伙伴或入驻用友云市场的第三方授权合作伙伴提供的，经您的明确同意，用友云将与其共享向您提供相应产品及服务所必需的个人信息；此外，为了与上述第三方授权合作伙伴共同开展市场推广活动，经您的明确同意，用友云可能与其共享开展活动所必需的以及在活动过程中产生的您的相关个人信息；<br />
                    4.1.5. 对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理用户信息。<br />
                    4.1.6. 为了向您提供一键分享服务，我们的产品集成友盟+ U-Share SDK，将收集您的设备标识信息（如IMEI/android ID/IDFA等）和您需要分享的社交账户公开信息，以便完成一键分享服务。为了您的信息安全，我们已与第三方SDK服务商进行数据安全保密约定，这些公司会严格遵守我们的数据隐私和安全要求。除非得到您的同意，我们不会与其共享您的个人身份信息。为便于您更好地了解【友盟+】采集的数据类型及用途，以及如何保护您的个人信息，您可以登陆（<a href="https://www.umeng.com/policy">https://www.umeng.com/policy</a>）了解【友盟+】隐私权政策<br />
                    4.1.7. 如您选择开通并使用用友云人脸相关服务，此服务将由百度智能云为您提供。为了方便您在不同场景和应用中使用其提供的人脸相关服务并提升人脸识别的准确性和安全性，百度智能云将保存您的<strong>人脸信息</strong>，并遵守百度智能云相关隐私政策及本政策。如我们更换前述人脸相关服务供应商，我们会按照法律要求重新取得您的同意。<br />
                    <strong>4.2.</strong>&nbsp;<strong>转让</strong><br />
                    我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：<br />
                    4.2.1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；<br />
                    4.2.2. 在用友云与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。<br />
                    <strong>4.3.</strong>&nbsp;<strong>公开披露</strong><br />
                    在对您的任何个人信息进行披露之前，我们会咨询您，并接受由您通过合同形式约定的个人信息披露内容。除了您的明确授权和法律法规要求，我们不会向其他人授权您的个人信息，我们仅会在以下情况下，公开披露您的用户个人信息：<br />
                    4.3.1. 获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息；<br />
                    4.3.2. &nbsp;或为保护用友云及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或用友云平台相关协议、规则披露关于您的用户信息。<br />
                    <strong>4.4. 共享、转让、公开披露用户信息时事先征得授权同意的例外</strong><br />
                    以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：<br />
                    4.4.1. 与国家安全、国防安全有关的；<br />
                    4.4.2. 与公共安全、公共卫生、重大公共利益有关的；<br />
                    4.4.3. 与犯罪侦查、起诉、审判和判决执行等有关的；<br />
                    4.4.4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
                    4.4.5. 您自行向社会公众公开的个人信息；<br />
                    4.4.6. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                </p>
                <h4>五、用户业务数据和公开信息</h4>
                <p>
                    不同于您的用户信息，对于用户业务数据和公开信息，用友云将按如下方式处理：<br />
                    <strong>5.1 用户业务数据</strong><br />
                    5.1.1. 您通过用友云提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的用户业务数据，您完全拥有您的用户业务数据。用友云作为企业云服务提供商，我们只会严格执行您的指示处理您的业务数据，除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。<br />
                    5.1.2. 您应对您的用户业务数据来源及内容负责，用友云提示您谨慎判断数据来源及内容的合法性。因您的用户业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。<br />
                    5.1.3. 为了优化服务质量和向您提供新的产品与服务，用友云会收集您于用友云相关产品内的交易数据、交易过程与订单信息进行数据分析并将上述业务数据（敏感信息除外）共享给用友云关联公司。<br />
                    <strong>5.2</strong>&nbsp;<strong>公开信息</strong><br />
                    5.2.1. 公开信息是指您公开分享的任何信息，任何人都可以在使用和未使用用友云网站服务期间查看或访问这些信息。<br />
                    5.2.2. 为使用用友云服务，可能存在您必须公开分享的信息。例如用友云市场为构建诚信交易环境，您的信用评价信息（星级、客户评价）需要被公开分享。若您是服务商（卖家），您应当根据适用的法律法规和用友云市场规则的要求，公开分享企业或者自然人经营者的相关信息。
                </p>
                <h4>六、用户个人信息的查询、更正与删除</h4>
                <p>
                    6.1您可以查看您提供给用友云的注册信息及使用用友云平台过程中产生的其他信息。如果您希望删除或更正您的信息，请通过用友云的客户隐私专用邮箱（<a href="mailto:privacy@yonyou.com">privacy@yonyou.com</a>）与我们联系。在您申请注销或删除帐号之后我们会在30个工作日内完成。<br />
                    6.2对于用友云收集的个人信息，如存在下述情形，您可以登入您的用友云平台账户，并依照相应页面的指示来删除您的账户，或移除特定个人信息：<br />
                    6.2.1. 您认为我们不再有必要持有您的个人信息；<br />
                    6.2.2. 我们曾取得您的同意来处理个人信息，且您事后收回同意（且我们并无其他理由处理该个人信息）；<br />
                    6.2.3. 您认为我们以非法方式处理您的个人信息； <br />
                    6.2.4. 在我们收集该个人信息时，您正值或未满 16 岁，且我们能够验证您的年龄。<br />
                    当您所在企业/组织用户注销用友云企业组织时，我们将会匿名化处理您在该组织的相关个人信息，但您作为用友云个人用户的个人信息仍将保留，除非您主动注销您的用友云个人账户。在您主动注销用友云个人账户之后，我们将停止为您提供用友云服务，并根据适用法律的要求对您的个人信息做匿名化处理。<br />
                    此外若您作为友空间个人用户时，您可以通过以下方式自动进行：<br />
                    登录友空间手机客户端，通过操作“我的 – 设置 – 帐号管理 – 更多 – 帐号注销“以完成删除您的个人信息，该操作是在确认删除后立即生效的。<br />
                    当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与其他信息分别存储，直到备份可以清除或实现匿名。
                </p>
                <h4>七、cookie和同类技术的使用方式</h4>
                <p>
                    7.1. 我们会在用友云服务上使用并允许其他特定公司使用 Cookie、网络信标以及其他同类技术。此举是为了了解您对用友云服务的使用情况，改善您的用户体验，并实现个性化的功能和内容，优化我们的广告和营销，以及让第三方广告公司协助我们通过互联网提供符合您兴趣的广告。<br />
                    7.2. 您可根据自己的偏好管理Cookie，您也可以清除设备上保存的所有 Cookie。大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问用友云网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。<br />
                    7.3. 除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。<br />
                    7.4. 关于用友云服务APP集成第三方SDK的说明。为保障我们客户端的运行，享受更多的服务和功能，我们的应用中会集成授权合作伙伴的SDK或其他类似的应用程序。集成的第三方SDK详情及收集的信息说明，参见附件二《用友云服务APP集成第三方SDK及收集信息说明》。我们会对授权合作伙伴的SDK和API进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本条款来处理个人信息。
                </p>
                <h4>八、用户个人信息的安全保护措施</h4>
                <p>
                    用友云及用友云的关联公司将采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不被丢失、泄露、毁损或滥用。用友云的供应商、合作伙伴或入驻用友云平台的第三方服务商将受到保密协议的约束，同时还将受到数据信息的权限控制和操作监控。<br />
                    当用友云认为用友云企业/组织用户的用户处理指令违反适用的法律或法规，用友云的客户隐私专用邮箱（<a href="mailto:privacy@yonyou.com">privacy@yonyou.com</a>）会以邮件的形式对用友云企业/组织管理员进行告知。
                </p>
                <h4>九、我们如何存储您的个人信息</h4>
                <p>
                    <strong>9.1. 存储地点：</strong>
                    我们将在中华人民共和国境内运营的用友云服务中收集和产生的个人信息存储在中华人民共和国境内。就中华人民共和国境外用友云用户使用用友云服务过程中产生的个人信息，我们将存储在新加坡的服务器上。如涉及向境外传输个人信息，我们将明确向您告知个人信息出境的目的、接收方、安全保障措施等情况，并另行征得您的同意。<br />
                    <strong>9.2. 存储期限：</strong>
                    我们会采取合理可行的措施存储您的个人信息，尽力避免收集无关的个人信息。
                    <strong>我们只会在在限于达成本政策所述目的所需的期限以及所适用法律法规所要求的期限内保留您的个人信息。</strong>
                    用友云将依据《中华人民共和国网络安全法》的要求，就您使用用友云应用服务留存相关的网络日志不少于六个月。
                </p>
                <h4>十、未成年人用户信息的特别约定</h4>
                <p>
                    10.1. 我们主要面向成人提供产品和服务。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。<br />
                    10.2. 对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
                </p>
                <h4>十一、用户其他权利条款</h4>
                <p>
                    对于用友云收集的个人信息，除了上述约定之外，您还可以行使如下权利：<br />
                    <strong>11.1个人信息的查询与修正</strong><br />
                    经您要求，用友云会告知您我们是否收集了您的个人信息；如确有收集行为，则您也有权得知我们收集您的个人信息种类、使用方式与共享对象。您有权随时登入您的用友云网站账户来查询并修正您的个人信息。在满⾜法律法规要求的最短保存期限要求的情况下，我们将对您的个⼈信息进⾏删除或匿名化处理。在上述法律法规要求的最短保存期限内，我们将不再对您的个⼈信息进⾏商业化使⽤。<br />
                    <strong>11.2个人信息仅限存储目的而处理</strong><br />
                    对于用友云收集的个人信息，如存在下述情形，你有权请求用友云除存储目的外将停止处理该等个人信息：<br />
                    11.2.1您认为该个人信息不正确（限于我们验证其是否正确之期间内）；<br />
                    11.2.2处理该个人信息为非法，我们因此希望消除该个人信息，但您希望我们保留该信息并仅存储之；或<br />
                    11.2.3用友云再无必要处理该个人信息并因此希望删除该个人信息，但您要求存储该信息，以便提出、主张或对抗法律救济。<br />
                    <strong>11.3个人信息的可携带性</strong><br />
                    对于用友云收集的个人信息，您有权取得副本。您有权以结构化、通用且机器可读之格式获得此信息。您也有权要求用友云将该个人信息移转给其他人或行使导出数据的权利。若您希望用友云将上述个人信息移转给第三方，请确保您会详述该第三方。如您要行使以上权利，请通过用友云的客户隐私专用邮箱（<a href="mailto:privacy@yonyou.com">privacy@yonyou.com</a>）与我们联系。请注意，用友云仅在技术上可行的情况下才能转移信息。一旦该第三方接收该个人信息后，对该信息之安全与否或对其处理方式，用友云概不负责。若提供特定个人信息会影响他人权利，则我们可能无法将之提供给您（例如，提供该个人信息会揭露他人信息、用友云或任何第三方的商业秘密或知识产权信息）。<br />
                    <strong>11.4个人信息收集和使用的拒绝权</strong><br />
                    如您之前已同意用友云收集并使用您的个人信息，在适用法律与规定的允许范围内，您可以撤回先前授予给我们的任何同意并有权拒绝我们使用该等个人信息。
                </p>
                <h4>十二、隐私权政策的更新</h4>
                <p>
                    我们可能会适时对本隐私权进行更新。当相关条款发生变更时，我们会在你登录及版本更新时以网站公示、推送通知、弹窗的形式向你展示变更后的隐私权政策。<strong>一旦您继续使用用友云服务，将被视为对更新后的隐私权政策的接受和认可。</strong>
                </p>
                <h4>十三、我们的联系方式</h4>
                <p>
                如您对本隐私权政策或对本隐私权政策的实践以及操作上有任何疑问和意见，可通过用友云的客户隐私专用邮箱（<a href="mailto:privacy@yonyou.com">privacy@yonyou.com</a>）与我们联系。
                </p>
                <br/>
                <h4>附件一：用友云服务信息收集明细</h4>
                <table>
                    <thead>
                        <tr>
                            <th><strong>业务线</strong></th>
                            <th><strong>收集的个人信息</strong></th>
                            <th><strong>收集目的和场景</strong></th>
                        </tr>   
                    </thead>
                    <tbody>
                        <tr>
                            <td>友空间</td>
                            <td>设备所在位置相关信息（例如ip地址、GPS位置以及能够提供位置信息的Wifi接入点、蓝牙和基站等传感器信息）、手机号、邮箱。</td>
                            <td>为您提供位置等相关服务，可以在聊天会话中发送位置和使用定位功能；<br />手机号和邮箱用于登录身份认证。</td>
                        </tr>
                        <tr>
                            <td>YonBIP费控</td>
                            <td>个人住址、住宿信息、工作所在地区。</td>
                            <td>用于差旅费报销。</td>
                        </tr>
                        <tr>
                            <td>YonBIP财资</td>
                            <td>金银行卡账号、交易记录、薪资信息。</td>
                            <td>用于支付，下载银行明细。</td>
                        </tr>
                        <tr>
                            <td>YonBIP税务云</td>
                            <td>姓名、头像、个人电话号码、个人邮箱、员工公司名称、员工编号、身份证号、及配偶姓名、身份证号。</td>
                            <td>用户登录、发票通过邮箱自动上传到个人票夹。公司及身份证信息，用于企业员工个税申报，录入信息用。</td>
                        </tr>
                        <tr>
                            <td>YonBIP人力云</td>
                            <td>姓名、头像、证件类型、证件号、性别、出生日期、婚姻状况、学历、邮箱、手机号、参加工作日期、姓名简拼、办公电话、通讯地址、个人邮箱<br />学位、籍贯、国籍地区、政治面貌、民族、加入党团时间、户口性质、户口所在地、血型、所属组织、所属部门、人脸信息。</td>
                            <td>收集内容最终由企业管理员决定，并应由企业管理者征求本企业员工的信息授权。<br />收集目的：企业员工管理；<br />场景：员工入职及自助填写；HR员工信息管理录入；考勤打卡等。</td>
                        </tr>
                        <tr>
                            <td>YonBIP协同云</td>
                            <td>手机号、姓名。</td>
                            <td>访客预约：公司统计来访人员的一些信息用于访客管理和验证来访人员身份；<br />云会务：统计来访人员的一些信息用于手机管理和验证来。</td>
                        </tr>
                        <tr>
                            <td>YonBIP采购云</td>
                            <td>手机号，邮箱、收货地址、IP地址。</td>
                            <td>用于业务消息订阅，如发货通知、专家评标确认及通知等；<br />用于电商商品配送；<br />用于询报价，招投标中的围标串标检测。</td>
                        </tr>
                        <tr>
                            <td>YonBIP营销云</td>
                            <td>手机号、出生日期、身份证件号、邮箱、收货地址。</td>
                            <td>营销沟通、商品发货。</td>
                        </tr>
                        <tr>
                            <td>YonBIP供应链云</td>
                            <td>姓名、手机号、收发货地址、银行账号。</td>
                            <td>供应链业务协同的必要信息。</td>
                        </tr>
                        <tr>
                            <td>YonBIP制造云</td>
                            <td>设备ip和位置、个人健康体检报告、病史、司机的手机号、身份证号、手机号，邮箱、用户手机号、客户联系人手机号，公众号用户手机号。</td>
                            <td>追溯服务；安环服务；物流；AIOT；设备服务。<br /></td>
                        </tr>
                        <tr>
                            <td>YonBIP资产云</td>
                            <td>位置定位。</td>
                            <td>满足移动点巡检业务。</td>
                        </tr>
                        <tr>
                            <td>YonBIP项目云</td>
                            <td>姓名、头像、个人电话号码、个人邮箱、企业邮箱。</td>
                            <td>项目相关人进行沟通和任务分配及其事件通知。</td>
                        </tr>
                        <tr>
                            <td>友户通</td>
                            <td>姓名、性别、生日、身份证、个人电话号码、个人邮箱、企业邮箱、唯一设备标识符、登录IP地址。</td>
                            <td>用户注册、登录。</td>
                        </tr>
                        <tr>
                            <td>智能分析</td>
                            <td>用户名、邮箱、手机号。</td>
                            <td>报表对象授权时参照使用。</td>
                        </tr>
                    </tbody>
                </table>
                <h4>附件二：用友云服务APP集成第三方SDK及收集信息说明</h4>
                <table>
                    <thead>
                        <tr>
                            <th><strong>SDK来源</strong></th>
                            <th><strong>功能描述</strong></th>
                            <th><strong>隐私权政策链接</strong></th>
                            <th><strong>收集的个人信息</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>阿里云存储OSS存储SDK</td>
                            <td>外部存储读取，访问网络</td>
                            <td>
                                <a href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.10695662.7y9jhqsfz.86.17883475PKzAAQ">
                                    http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.10695662.7y9jhqsfz.86.17883475PKzAAQ
                                </a>
                            </td>
                            <td>无</td>
                        </tr>
                        <tr>
                            <td>华为存储OBS存储SDK</td>
                            <td>外部存储读取，访问网络</td>
                            <td>
                                <a href="https://cloud.baidu.com/doc/Agreements/s/Kjwvy245m">
                                    https://www.huaweicloud.com/declaration/sa_prp.html
                                </a>
                            </td>
                            <td>无</td>
                        </tr>
                        <tr>
                            <td>百度</td>
                            <td>人脸识别主要用于人脸签到</td>
                            <td>
                                <a href="https://cloud.baidu.com/doc/Agreements/s/Kjwvy245m">
                                    https://cloud.baidu.com/doc/Agreements/s/Kjwvy245m
                                </a>
                            </td>
                            <td>相机权限和访问照片权限</td>
                        </tr>
                        <tr>
                            <td>高德</td>
                            <td>用于地理位置定位、考勤打卡</td>
                            <td>
                                <a href="https://lbs.amap.com/home/privacy/">
                                    https://lbs.amap.com/home/privacy/
                                </a>
                            </td>
                            <td>地理位置信息、设备信息</td>
                        </tr>
                        <tr>
                            <td>华为</td>
                            <td>用于华为手机的通知推送</td>
                            <td>
                                <a href="https://consumer.huawei.com/cn/privacy/privacy-policy/">
                                    https://consumer.huawei.com/cn/privacy/privacy-policy/
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>小米</td>
                            <td>用于小米手机的通知推送</td>
                            <td>
                                <a href="https://dev.mi.com/console/doc/detail?pId=1822">
                                    https://dev.mi.com/console/doc/detail?pId=1822
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>魅族</td>
                            <td>用于魅族手机的通知推送</td>
                            <td>
                                <a href="https://i.flyme.cn/privacy">
                                    https://i.flyme.cn/privacy
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>VIVO</td>
                            <td>用于vivo手机的通知推送</td>
                            <td>
                                <a href="https://dev.vivo.com.cn/documentCenter/doc/366">
                                    https://dev.vivo.com.cn/documentCenter/doc/366
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>OPPO</td>
                            <td>用于oppo手机的通知推送</td>
                            <td>
                                <a href="https://muc.heytap.com/document/heytap/privacyPolicy/privacyPolicy_zh-CN.html">
                                    https://muc.heytap.com/document/heytap/privacyPolicy/privacyPolicy_zh-CN.html
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>腾讯</td>
                            <td>用于分享到QQ、微信</td>
                            <td>
                                <a href="https://www.wechat.com/zh_CN/privacy_policy.html">
                                    https://www.wechat.com/zh_CN/privacy_policy.html
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>随锐科技-瞩目</td>
                            <td>用于实现视频会议的能力</td>
                            <td>
                                <a href="https://www.zhumu.me/PrivacyPolicy.html">
                                    https://www.zhumu.me/PrivacyPolicy.html
                                </a>
                            </td>
                            <td>相机、麦克风权限</td>
                        </tr>
                        <tr>
                            <td>科大讯飞</td>
                            <td>用于实现语音转文字、语音识别功能</td>
                            <td>
                                <a href="https://www.xfyun.cn/doc/policy/privacy.html">
                                    https://www.xfyun.cn/doc/policy/privacy.html
                                </a>
                            </td>
                            <td>麦克风权限</td>
                        </tr>
                        <tr>
                            <td>Tinker（腾讯）</td>
                            <td>在线热修复</td>
                            <td>
                                <a href="https://www.gitmemory.com/Tencent/tinker">
                                    https://www.gitmemory.com/Tencent/tinker
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>Bugly（腾讯）</td>
                            <td>应用崩溃收集</td>
                            <td>
                                <a href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf">
                                    https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                        <tr>
                            <td>友盟</td>
                            <td>数据统计</td>
                            <td>
                                <a href="https://www.umeng.com/policy">
                                    https://www.umeng.com/policy
                                </a>
                            </td>
                            <td>设备标识符</td>
                        </tr>
                    </tbody>
                </table>
                <h4>附件三：友空间APP功能、权限与收集的个人信息</h4>
                <table>
                    <thead>
                        <tr>
                            <th><strong>业务功能</strong></th>
                            <th><strong>申请开启手机权限</strong></th>
                            <th><strong>收集的个人信息</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>通讯录-添加手机联系人</td>
                            <td>通讯录权限</td>
                            <td>手机通讯录信息</td>
                        </tr>
                        <tr>
                            <td>通讯录-添加好友</td>
                            <td>通讯录权限</td>
                            <td>通讯录-添加好友</td>
                        </tr>
                        <tr>
                            <td>查看手机通讯录</td>
                            <td>通讯录权限</td>
                            <td>通讯录-添加好友</td>
                        </tr>
                        <tr>
                            <td>人脸打卡</td>
                            <td>面容ID权限</td>
                            <td>人脸图像</td>
                        </tr>
                        <tr>
                            <td>面容解锁</td>
                            <td>面容ID权限</td>
                            <td>人脸图像</td>
                        </tr>
                        <tr>
                            <td>指纹解锁</td>
                            <td>指纹权限</td>
                            <td>指纹特征值</td>
                        </tr>
                        <tr>
                            <td>考勤打卡</td>
                            <td>位置权限</td>
                            <td>位置信息</td>
                        </tr>
                        <tr>
                            <td>考勤打卡</td>
                            <td>获取设备信息权限</td>
                            <td>允许app获取设备IMEI号</td>
                        </tr>
                        <tr>
                            <td>考勤打卡</td>
                            <td>获取设备信息权限</td>
                            <td>允许app获取设备MAC地址，以识别考勤打卡位置</td>
                        </tr>
                        <tr>
                            <td>更换头像</td>
                            <td>相机、照片读取和写入权限</td>
                            <td>允许app读取存储的图片、视频</td>
                        </tr>
                        <tr>
                            <td>单聊上传图片或视频</td>
                            <td>相机、照片读取和写入权限</td>
                            <td>允许app读取存储的图片、视频</td>
                        </tr>
                        <tr>
                            <td>群聊上传图片或视频</td>
                            <td>相机、照片读取和写入权限</td>
                            <td>允许app读取存储的图片、视频</td>
                        </tr>
                        <tr>
                            <td>工作圈上传图片或视频</td>
                            <td>相机、照片读取和写入权限</td>
                            <td>允许app读取存储的图片、视频</td>
                        </tr>
                        <tr>
                            <td>业务应用上传图片或视频</td>
                            <td>相机、照片读取和写入权限</td>
                            <td>允许app读取存储的图片、视频</td>
                        </tr>
                        <tr>
                            <td>小视频录制</td>
                            <td>相机、照片读取和写入、麦克风权限</td>
                            <td>语音信息</td>
                        </tr>
                        <tr>
                            <td>语音输入</td>
                            <td>麦克风权限</td>
                            <td>语音信息</td>
                        </tr>
                        <tr>
                            <td>语音会议/视频会议</td>
                            <td>麦克风权限</td>
                            <td>语音信息</td>
                        </tr>
                        <tr>
                            <td>智多星唤醒和问答</td>
                            <td>麦克风权限</td>
                            <td>语音信息</td>
                        </tr>
                        <tr>
                            <td>同步手机日程功能</td>
                            <td>日历权限</td>
                            <td>同步手机日程到友空间</td>
                        </tr>
                        <tr>
                            <td>通讯录个人详情</td>
                            <td>拨打电话权限</td>
                            <td>允许拨打电话</td>
                        </tr>
                        <tr>
                            <td>应用启动</td>
                            <td>sd卡存储权限</td>
                            <td>允许app读取存储的文件</td>
                        </tr>
                        <tr>
                            <td>应用登录</td>
                            <td>读取手机状态信息权限</td>
                            <td>手机状态信息</td>
                        </tr>
                        <tr>
                            <td>来电身份识别</td>
                            <td>读取通话记录、悬浮窗权限</td>
                            <td>读取通话记录</td>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <p>
                    您理解并同意，上述附加服务所需要的通讯录、地理位置、摄像头、麦克风、相册、日历权限，均不会默认开启，只有经过您的明确授权后才会在为实现上述相关功能或服务时使用，您也可以在您的设备中查看上述权限的状态，并可以随时撤回授权。特别需要指出的是，即使经过了您的授权，我们获得了这些敏感权限，也不会在相关功能和服务不需要时收集这些信息。<br />
                </p> 
            </div>
        )
    }
}
